
import { InteractionRequiredAuthError } from "@azure/msal-browser"
import { useMsal } from "@azure/msal-react"
import React, { useEffect, useState } from "react"

import { loginRequest } from "./authConfig"

// Define types for user data
interface UserData {
  displayName: string;
  id: string;
  mail: string;
  userPrincipalName: string;
}

const LoginPage: React.FC = () => {
  const { accounts, instance } = useMsal()
  const [userData, setUserData] = useState<UserData | null>(null)
  const [loading, setLoading] = useState<boolean>(true) // Add loading state
  useEffect(() => {
    if (accounts.length === 0) {
      login() 
    } else {
      getUserData() 
    }
  }, [accounts])

  // Handle redirect response after returning from ADFS
  useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) console.log("Login Successful", response)
      })
      .catch((error) => {
        console.error("Redirect Error", error)
      })
  }, [])

  const login = () => {
    instance.loginRedirect(loginRequest)
      .then((response:any) => {
        console.log("Login successful", response)

        // Access token is typically found in the response object (depending on the library you're using)
        const accessToken = response.accessToken
    
        if (accessToken) {
          // Store the access token in localStorage (or use a state management tool like Redux if needed)
          localStorage.setItem('access_token', accessToken)
          
          // Optionally, call getUserData() or other functions here to utilize the access token
          // getUserData(accessToken);
        }
      })
      .catch((error) => {
        console.error("Login error", error)
        setLoading(false) 
      })
  }

  const logout = () => {
    instance.logoutRedirect()
      .then(() => {
        console.log("Logged out successfully")
        setUserData(null) 
      })
      .catch((error) => {
        console.error("Logout error", error)
      })
  }

  const getUserData = async () => {
    if (accounts.length > 0) {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })

        const userDataResponse = await fetch("https://graph.microsoft.com/v1.0/me", {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        }).then((res) => res.json())
       console.log(userDataResponse)
        setUserData(userDataResponse)
        setLoading(false) 
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          instance.acquireTokenPopup(loginRequest)
            .then((response) => {
              return getUserData() 
            })
            .catch((error) => {
              console.error("Error acquiring token", error)
              setLoading(false)
            })
        } else {
          console.error("Error fetching user data", error)
          setLoading(false)
        }
      }
    }
  }

  return (
    <div>
      {/* {loading ? (
        <p>Loading...</p> 
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {!userData ? (
            <p>Login failed or user data not found. Please try again.</p>
          ) : (
            <div>
              <h2>Welcome, {userData.displayName}</h2>
              <button onClick={logout}>Logout</button>
              <div>
                <h3>User Data:</h3>
                <pre>{JSON.stringify(userData, null, 2)}</pre>
              </div>
            </div>
          )}
        </>
      )} */}
    </div>
  )
}

export default LoginPage